export const flavorRange = (flavor) => (
  flavor?.range_type === "guest" ? "guest" : flavor?.range_type === "economy" ? "economy" : "dreamlabs"
);

export const guestBrand = (flavor) => {
  const brand = typeof flavor?.brand_name === "string" ? flavor.brand_name.trim() : "";
  return brand || "Premium Brands";
};

export const groupFlavorsByRange = (flavors = []) => {
  const dreamlabs = [];
  const economy = [];
  const guestMap = new Map();

  flavors.forEach((flavor) => {
    const range = flavorRange(flavor);
    if (range === "economy") {
      economy.push(flavor);
      return;
    }
    if (range !== "guest") {
      dreamlabs.push(flavor);
      return;
    }

    const brand = guestBrand(flavor);
    if (!guestMap.has(brand)) guestMap.set(brand, []);
    guestMap.get(brand).push(flavor);
  });

  return {
    dreamlabs,
    economy,
    guestGroups: Array.from(guestMap, ([brand, groupedFlavors]) => ({
      brand,
      flavors: groupedFlavors,
    })),
  };
};
